export default __webpack_public_path__ + "images/0xde5ed76e7c05ec5e4572cfc88d1acea165109e44.png";